import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MRLogo } from "./MRLogo";

export const Loader = ({ ready }) => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let id;
    if (ready) id = setTimeout(() => setHidden(true), 600);
    const failsafe = setTimeout(() => setHidden(true), 2600);
    return () => {
      clearTimeout(id);
      clearTimeout(failsafe);
    };
  }, [ready]);

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-stage"
        >
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="text-primary"
          >
            <MRLogo className="w-[125px]" />
          </motion.div>
          <div className="mt-10 h-px w-44 overflow-hidden bg-border">
            <div className="h-full w-full bg-primary animate-loader-fill" />
          </div>
          <span className="mt-5 text-[11px] uppercase tracking-[0.3em] text-muted-foreground">
            Carregando experiência
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
